import { GetRequest, PutRequest } from "./RequestTemplates";

export const checkReferralEligibility = async (userId: string) => {
  return GetRequest(`${process.env.API_SERVER_URL}/tariff/user-raf-eligibility-check/${userId}`).then(
    (res) => res.data
  );
};

export const updateUserOnboarding = async (userId: string) => {
  return PutRequest(`${process.env.API_SERVER_URL}/users/onboard/${userId}`, {}).then((res) => res.data);
};
